// Authentication API functions
import apiClient, { unwrapResponse } from './client';
import type { User, AuthResponse, LoginRequest, RegisterRequest, SuccessEnvelope } from './types';

export const authApi = {
  /**
   * Register a new user
   */
  async register(data: RegisterRequest): Promise<User> {
    const response = await apiClient.post<SuccessEnvelope<User>>('/auth/register', data);
    return unwrapResponse(response);
  },

  /**
   * Login with email and password
   */
  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await apiClient.post<SuccessEnvelope<AuthResponse>>('/auth/login', data);
    const authData = unwrapResponse(response);
    
    // Store token if provided
    if (authData.token) {
      localStorage.setItem('auth_token', authData.token);
    }
    
    return authData;
  },

  /**
   * Logout current user
   */
  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
    localStorage.removeItem('auth_token');
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<SuccessEnvelope<User>>('/auth/me');
    return unwrapResponse(response);
  },
};

export default authApi;
